import { ReactElement } from 'react';
import { getPageByStep } from '../GetPageByStep';
import { navigationStepsOrder } from '../NavigationStepsOrder';
import { Steps } from '../Steps';
import { useViewProvider } from '../../contexts/view-provider-context/ViewProvider';
import { useBrandNavigate } from '../../navigation/UseBrandNavigate';
import { useBookingContext } from '../../booking-state/UseBookingContext';
import { StepNavigation, StepsNavigationViewProps } from './StepsNavigationViewProps';
import { useTracking } from '../../../tracking';

export interface StepsNavigationModalProps {
  currentStep: Steps;
}

export function StepsNavigation({ currentStep }: StepsNavigationModalProps): ReactElement {
  const viewProvider = useViewProvider();
  const [bookingState] = useBookingContext();
  const navigate = useBrandNavigate();

  const currentStepIndex = navigationStepsOrder.findIndex((step) => step === currentStep);
  const stepNavigations: StepNavigation[] = navigationStepsOrder.map((step, stepIndex) => {
    const isPassedStep = stepIndex < currentStepIndex;
    const isCurrentStep = stepIndex === currentStepIndex;
    const pageToNavigate = getPageByStep(step, bookingState);
    const navigationEnabled = !!((isCurrentStep || isPassedStep) && pageToNavigate);
    const trackingService = useTracking();

    const onNavigateToStep = (): void => {
      trackingService.trackStepButtonClick({ contentId: "step" });
      
      if (isPassedStep) {
        navigate(pageToNavigate!);
      }
    };

    return {
      step,
      navigationEnabled,
      onNavigateToStep,
    };
  });

  const viewProps: StepsNavigationViewProps = {
    steps: stepNavigations,
    currentStep: navigationStepsOrder[currentStepIndex],
  };

  return viewProvider.renderStepsNavigation(viewProps);
}
